// extracted by mini-css-extract-plugin
export var actionText = "_nb-4";
export var container = "_nb-0";
export var leftSection = "_nb-1";
export var rightSection = "_nb-2";
export var settingsButton = "_nb-6";
export var settingsIcon = "_nb-7";
export var shortcut = "_nb-5";
export var shortcutGroup = "_nb-3";